<template>
    <div :class="classes" role="alert">
        <div class="container-alert">
            <span v-if="level === 'success'" class="material-symbols-rounded full-circle">check</span>

            <span v-if="level === 'warning'" class="material-symbols-rounded full-circle">priority_high</span>

            <span v-if="level === 'danger'" class="material-symbols-rounded">warning</span>

            <div class="flash-alert--text" v-html="text"></div>

            <button class="flash-alert--close" @click="closeAlert">
                <span class="material-symbols-rounded">close</span>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            text: {
                type: String,
                required: true
            },
            level: {
                type: String,
                default: 'success',
                validator: function (value) {
                    return ['success', 'warning', 'danger'].indexOf(value) !== -1
                }
            },
            static: {
                type: Boolean,
                default: false
            },
            position: {
                type: String,
                default: 'bottom-right',
                validator: function (value) {
                    return ['bottom-right', 'top'].indexOf(value) !== -1
                }
            }
        },

        data() {
            return {
                isActive: true
            }
        },

        mounted() {
            var letterCount = this.text.length

            if (letterCount < 45) {
                letterCount = 45
            }

            setTimeout(() => {
                this.closeAlert()
            }, letterCount * 150)

            if(this.position === 'top') {
                var notificationHeight = 0;

                if(document.querySelector('.notification') !== null) {
                    notificationHeight = document.querySelector('.notification').getBoundingClientRect().height;
                }
                
                var headerHeight = document.querySelector('.site-header').getBoundingClientRect().height;

                this.$el.style.top = headerHeight + notificationHeight + 16 + 'px';
            }
        },

        computed: {
            classes() {
                return {
                    'flash-alert': true,
                    'flash-alert--active': this.isActive,
                    [`flash-alert--${this.level}`]: this.level ? true : false,
                    'flash-alert--static': this.static,
                    [`flash-alert--${this.position}`]: true,
                }
            }
        },
        methods: {
            closeAlert() {
                this.isActive = false
                this.$emit('closeAlert', true)
            }
        }
    }
</script>
